module.exports = __webpack_public_path__ + "static/img/ranking1.eaed5c85.png";